import { convert } from 'convert';

export function poundsToKilos(pounds: number) {
  return Math.round(convert(pounds, 'pounds').to('kilograms') * 10e6) / 10e6;
}

export function kilosToPounds(kilos: number) {
  return Math.round(convert(kilos, 'kilograms').to('pounds') * 10e6) / 10e6;
}
